import ProgressBarContainer from './ProgressBar.styles';
import { useState, useEffect } from 'react';
import { TABS } from '@/utils/common';

type ProgressBarProps = {
  currentStep: number;
  familyData: boolean;
};

export const ProgressBar = ({ currentStep, familyData }: ProgressBarProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const current = currentStep + +familyData;
    const steps = TABS.length + +familyData;
    setProgress((current / steps) * 100);
  }, [currentStep, familyData]);

  return <ProgressBarContainer progress={progress} />;
};
